export const colors = {
  // primaryBase: "#1A5CFF",
  primaryBase: "#07171E",
  textBase: "#40506A",
  textLight: "#091E42",
};
